
import React, { useState } from "react";
import * as rb from "react-bootstrap";
import { useMessageModalContext } from "../MessageModal";
import { CodeBlock } from '../../../../_metronic/partials'

export const ErrorModal = () => {
    const [showStack, setShowStack] = useState(false)
    const { hideModal, store } = useMessageModalContext();
    const { modalProps } = store || {};
    const { title, userMessage, errorCleanMessage, stackTrace } = modalProps.request?.response == null ? modalProps : JSON.parse(modalProps.request.response)

    const handleModalToggle = () => {
        hideModal();
    };

    return (
        <rb.Modal className= { 'dialog-modal' } show = { true } centered onHide = { handleModalToggle } >
            <rb.Modal.Header closeButton>
                <rb.Modal.Title>

                    <div className="row">
                        <div className="col-lg-2 flex-center">
                            <i className="bi bi-exclamation-triangle-fill text-danger fs-2x"></i>
                        </div>
                        <div className="col-lg-10 flex-center">
                            {title}
                        </div>
                    </div>

                </rb.Modal.Title>

            </rb.Modal.Header>
            <rb.Modal.Body className = { 'pre-wrap'} >

                <div className="row mb-6">
                    <div className="col-lg-12 flex-center">
                        <div dangerouslySetInnerHTML={{ __html: userMessage }} />
                    </div>
                </div>
                {errorCleanMessage != undefined && errorCleanMessage != '' ?
                    <div className="row">
                        <div className="col-lg-12 text-inverse-light bg-light pt-2 pb-6 scroll" style={{ maxHeight: '150px' }}>
                            <b>System Error:</b><br />
                            {errorCleanMessage}
                        </div>
                    </div> : null}

                {stackTrace != undefined && stackTrace != '' ? <div className="row">
                    <div className="col-lg-12 pt-2 pb-6">
                        <a href="#" className="pointer" onClick={() => setShowStack(!showStack)}>See Stack Trace</a>
                    </div>
                </div> : null}

                {showStack && stackTrace != '' ? <div className="row">
                    <div className="col-lg-12 pt-2 pb-6">
                        <CodeBlock language="bash" code={stackTrace} />
                    </div>
                </div> : null}

                

            </rb.Modal.Body>
            <rb.Modal.Footer>
                <rb.Button variant= "primary btn-block" onClick = { handleModalToggle } >Ok</rb.Button>
            </rb.Modal.Footer>
        </rb.Modal>
    );
};